import Footer from "components/footer/Footer";
import Header from "components/header/Header";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="w-screen min-h-screen bg-whitecream overflow-hidden">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}
